import * as React from 'react';
import { CommodityGroup } from '@shapeable/copper-connect-types';

export const CommodityGroupsContext = React.createContext<CommodityGroup[]>([]);
export const CommodityGroupsProvider = CommodityGroupsContext.Provider;